import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Trash2 } from 'lucide-react';

import ConfirmActionModal from '../member-detail/ConfirmActionModal';

/**
 * Confirm dialog of Delete role. `onConfirm` resolves `true` when the role was deleted (the
 * caller leaves the page) and `false` when it failed (the dialog stays open).
 *
 * @param {object} props
 * @param {object|null} props.role Role being deleted; the dialog is closed when null.
 * @param {() => void} props.onClose
 * @param {() => Promise<boolean>} props.onConfirm
 */
const DeleteRoleModal = ({ role, onClose, onConfirm }) => {
  const { t } = useTranslation('people-access');
  if (!role) return null;

  return (
    <ConfirmActionModal
      isOpen
      icon={Trash2}
      title={t('roles.detail.deleteModal.title', { name: role.name })}
      message={t('roles.detail.deleteModal.message')}
      confirmLabel={t('roles.detail.deleteModal.confirm')}
      confirmVariant="danger"
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default memo(DeleteRoleModal);
